<template>
  <div class="new-dialog">
    <el-dialog :title="edit?'编辑邮箱':'添加邮箱'" :visible.sync="visible" width="480px" top="calc((100vh - 240px) / 2)" :close-on-click-modal="false" :before-close="closeDialog">
      <!-- 添加邮箱 -->
      <div class="step" v-if="!edit">
        <EmailVerify @success="handAddEmail" @onClose="closeDialog" submitBtnTxt="保 存" emailName="邮箱" />
      </div>
      <!-- 编辑邮箱 -->
      <div v-if="edit">
        <div class="steps-nav">
          <ul class="steps">
            <li v-for="(item,index) in setData" :key="index" :class="{'active':steps===index}">
              <div class="steps-content">{{item.name}}</div>
            </li>
          </ul>
        </div>
        <div class="steps-box" v-if="steps  == 0">
          <EmailVerify ref="verifyOne" @success="handVerifyEmail"  @onClose="closeDialog" submitBtnTxt="下一步" emailName="原邮箱" />
        </div>
        <div class="steps-box" v-if="steps  == 1">
          <EmailVerify @success="handAddEmail" @onClose="closeDialog"  submitBtnTxt="保 存"  emailName="新邮箱"/>
        </div>
        <div class="steps-box" v-if="steps  == 2">
          <div class="success">
            <el-result icon="success" title="修改成功～" subTitle=""></el-result>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="closeDialog()">知道了</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
import EmailVerify from "./EmailVerify"

export default {
  name: "email",
  props: {
    visible: Boolean,
    edit:Boolean,
  },
  components:{EmailVerify},
  data(){
    return{
      steps:0,
      count:0,
      loading:false,
      codeIsSend: false,
      showVerCode:false,
      submiting:false,
      codeSend:false,
      errorCode: '',
      setData:[{name:'验证身份'},{name:'新邮箱'},{name:'修改完成'}],
    }
  },
  methods:{
    getEditEmail(email){
      this.steps  = 0
      setTimeout(()=>{this.$refs.verifyOne.formData.email = email},1)
    },
    // 添加邮箱
    handAddEmail(form){
         let params = form
           params.newEmail = form.email
          httpAjax({
            url:'/services/user/changeEmail',
            method:'post',
            data: params
          }).then((response) => {
            if(response.success) {
              if(this.edit){
                 this.steps =  2
              }else{
                this.closeDialog()
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              }
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          });
    },
    //  老邮箱验证
    handVerifyEmail(form){
          let params = {
            email:form.email,
            code:form.verifyCode
          }
          httpAjax({
            url:'/services/verify/send/verifySms/email/check',
            method:'get',
            data: params
          }).then((response) => {
            if(response.success) {
              this.steps = null
              setTimeout(()=>{this.steps =  1},1)
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          });
    },
    //  关闭
    closeDialog(){
      this.$parent.emailVisible = false
      this.$parent.getCurrentCompany()
    }
  },
  destroyed(){
  }
  
}
</script>

<style scoped lang="less">
.steps-nav {
  display: flex;
  justify-content: center;
}

.steps-box {
  text-align: center;
  padding: 16px 0;
  .success{
    padding: 16px 0 32px;
  }
}

.dialog-footer {
  text-align: center;
}
</style>